var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"under-construction-page"},[_c('div',{staticClass:"top"},[_c('AtomLocaleSwitch'),_vm._v(" "),_c('AtomLogo')],1),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('message')))]),_vm._v(" "),_c('NuxtLink',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t('buttonText')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }